export const defaultInstructions = `# {{vars.EVENT_NAME}}

---

## Welcome.

Here are the step by step instructions to run the Hands on Lab:

<a href="https://app.dataops.live/{{vars.CONFIGURE_PROJECT_PATH_WITH_NAMESPACE}}/documentations/{{vars.CONFIGURE_PIPELINE_ID}}?job={{vars.CONFIGURE_PROJECT_HOMEPAGE_JOB_ID}})" target="_blank" rel="noopener noreferrer">
  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="50">
    <rect x="0" y="0" width="200" height="50" rx="10" ry="10" fill="#11567f" />
    <text x="100" y="30" font-family="Arial, sans-serif" font-size="16" fill="white" text-anchor="middle">
        Lab Instructions
    </text>
  </svg>
</a>

<br>

## Snowflake Account Details

### Your temporary Snowflake account

<div class="mt-6 border-t border-gray-100">
  <dl class="divide-y space-y-2 divide-gray-100">
    <div class="px-4  grid grid-cols-4">
      <dt class="text-md/6 font-medium text-gray-900">URL</dt>
      <dd class="text-md/6 text-gray-700 col-span-3"><a href="https://{{vars.DATAOPS_SNOWFLAKE_ACCOUNT}}.snowflakecomputing.com" target="_blank" rel="noopener noreferrer">https://{{vars.DATAOPS_SNOWFLAKE_ACCOUNT}}.snowflakecomputing.com</a></dd>
    </div>
    <div class="px-4  grid grid-cols-4">
      <dt class="text-md/6 font-medium text-gray-900">Username</dt>
      <dd class="text-md/6 text-gray-700 col-span-3">{{vars.SNOWFLAKE_USER}}</dd>
    </div>
    <div class="px-4  grid grid-cols-4">
      <dt class="text-md/6 font-medium text-gray-900">Password</dt>
      <dd class="text-md/6 text-gray-700 col-span-3">{{vars.SNOWFLAKE_PASSWORD}}</dd>
    </div>
  </dl>
</div>
`;
